import { useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';

import { useFreecodeContextRun, useFreecodeContextData } from 'hooks/useContext';
import services from 'api/services';
const { FreecodeRunService } = services;

export default function useTestRunFunction() {
  const { ticket } = useFreecodeContextData();
  const { setRunFunction, updateRunResponse, setIsRunning, isRunningRef, codeSolRef, languageRef, runHiddenRef } =
    useFreecodeContextRun();

  const runFunction = useCallback(() => {
    if (isRunningRef.current || !ticket?._id) return;
    setIsRunning(true);
    const doRun = async () => {
      try {
        let runBody = {
          ticket: ticket._id,
          code: codeSolRef.current,
          language: languageRef.current,
        };
        if (runHiddenRef.current) runBody.runHidden = runHiddenRef.current;
        const runResult = await FreecodeRunService.runTicket(runBody);
        updateRunResponse(runResult);
      } catch (error) {
        console.error('Run error:', error);
        toast.error('Run error ' + (error?.message || 'internal Error'));
        updateRunResponse(undefined);
      } finally {
        setIsRunning(false);
      }
    };
    doRun();
  }, [isRunningRef, ticket?._id, setIsRunning, codeSolRef, languageRef, runHiddenRef, updateRunResponse]);

  useEffect(() => setRunFunction(() => runFunction), [runFunction, setRunFunction]);
}
